import React from "react";
import { PACKAGE_STEPS, TOTAL_STEPS } from "../../../constants";
import { StepIndex } from "../../../types/PackageForm";
import useTranslate from "../../../../core/languages/hooks/useTranslate";

interface StepIndicatorProps {
    currentStep: StepIndex;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => {
    const t = useTranslate();

    return (
        <div className="mb-8">
            {/* Barra de progreso */}
            <div className="flex justify-between mb-6">
                {Array.from({ length: TOTAL_STEPS }).map((_, index) => {
                    const stepNumber = (index + 1) as StepIndex;
                    const isCompleted = stepNumber < currentStep;
                    const isCurrent = stepNumber === currentStep;

                    return (
                        <div key={stepNumber} className="flex items-center flex-1">
                            {/* Círculo del paso */}
                            <div
                                className={`w-8 h-8 rounded-full flex items-center justify-center font-semibold text-sm transition-all ${
                                    isCurrent
                                        ? "bg-primary-600 text-white ring-4 ring-primary-200 dark:ring-primary-900"
                                        : isCompleted
                                            ? "bg-green-600 text-white"
                                            : "bg-neutral-200 dark:bg-neutral-700 text-neutral-600 dark:text-neutral-400"
                                }`}
                            >
                                {isCompleted ? (
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                ) : (
                                    stepNumber
                                )}
                            </div>

                            {/* Línea conectora */}
                            {stepNumber < TOTAL_STEPS && (
                                <div
                                    className={`flex-1 h-1 mx-2 transition-all ${
                                        isCompleted
                                            ? "bg-green-600"
                                            : "bg-neutral-200 dark:bg-neutral-700"
                                    }`}
                                />
                            )}
                        </div>
                    );
                })}
            </div>

            {/* Labels de los pasos */}
          <div className="grid grid-cols-6 gap-2 mb-6">
               {Array.from({ length: TOTAL_STEPS }).map((_, index) => {
                   const step = (index + 1) as StepIndex;
                   const stepConfig = PACKAGE_STEPS[`STEP_${step}` as keyof typeof PACKAGE_STEPS];
                   const isCurrent = step === currentStep;

                    return (
                        <div key={step} className="text-center">
                            <p
                                className={`text-xs font-medium transition-colors ${
                                    isCurrent
                                        ? "text-primary-600 dark:text-primary-400"
                                        : "text-neutral-600 dark:text-neutral-400"
                                }`}
                            >
                                {t(stepConfig.label)}
                            </p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default StepIndicator;


